import { baseApi } from './baseApi';
import type { City } from '@nimbazaar/types';
import { API_ENDPOINTS } from '@nimbazaar/constants';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export const citiesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCities: builder.query<ApiResponse<Pick<City, 'id' | 'name'>[]>, void>({
      query: () => API_ENDPOINTS.CITIES.BASE,
      providesTags: ['Cities'],
    }),
  }),
});

export const { useGetCitiesQuery } = citiesApi;
